import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  chartScoresHistogram: {
    width: '100%',
    height: 'auto',
    fontFamily: 'inherit',
    color: t.baseTextColor,
  },

  threshold: {
    stroke: 'red',
    strokeDasharray: 4,
  },

  thresholdText: {
    fill: 'currentColor',
    fontSize: '.7rem',
  },

  anomalyBar: {
    fill: t.red01,
    opacity: 0.6,
  },

  normalBar: {
    fill: t.green01,
    opacity: 0.6,
  },

  xAxisLabel: {
    textAnchor: 'middle',
    fill: 'currentColor',
    fontSize: '.8rem',
    textTransform: 'uppercase',
    fontWeight: 600,
  },

  thresholdSimulationDiv: {
    borderBottom: '0.0625rem solid #dcdcdc',
    padding: '0.15rem 0',
    fontSize: '0.9rem',
    borderTop: '0.0625rem solid #dcdcdc',
    minHeight: '1.9063rem',
    alignItems: 'center',
    display: 'flex',
  },

  thresholdSimulationText: {
    color: '#bc31a2',
    fontSize: '.7rem',
    textTransform: 'uppercase',
    fontWeight: 600,
  },

  thresholdSimulation: {
    minWidth: '40%',
    marginLeft: '0.5rem',
  },

  thresholdSimulationTxt: {
    maxWidth: '26%',
    border: '0.0625rem solid transparent',
    borderRadius: '0.25rem',
  },

  refreshButtonShow: {
    display: 'unset',
  },

  refreshButtonHide: {
    display: 'none',
  },
}))

export default useStyles
